import { render, staticRenderFns } from "./CustomerSegment.vue?vue&type=template&id=c67ce4b2&scoped=true&lang=pug&"
import script from "./CustomerSegment.vue?vue&type=script&lang=js&"
export * from "./CustomerSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67ce4b2",
  null
  
)

export default component.exports